import React from 'react'
import { connect } from "react-redux"
import {find} from 'lodash'
import styled from 'styled-components'
import { partners } from "../../../../data"

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-content: center;
  align-items: center;
  background-color: rgb(242, 245, 255);
`

const Image = styled.img`
  width: 72vw;
  height: 50vw;
`

const Text = styled.div`
  font-size: 25px;
`
const LoadingPage = (props) => (
  <Wrapper>
    <Text />
    <Image src={props.partnerId ? find(partners, {_id: props.partnerId}).loadinglogo : "/static/small_logo.png"} />
    <Text>请等几秒钟...</Text>
    <Text />
  </Wrapper>
)

const mapStateToProps = (state, _ownProps) => ({
  partnerId: state.userInfo.partnerId, 
})

export default connect(mapStateToProps)(LoadingPage)


// WEBPACK FOOTER //
// ./src/app/catalogo/components/LoadingPage.jsx